// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from folder-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function FolderFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M16 5v8.5a1.5 1.5 0 0 1-1.356 1.493L14.5 15h-13a1.5 1.5 0 0 1-1.493-1.356L0 13.5V5h16ZM0 2.5a1.5 1.5 0 0 1 1.356-1.493L1.5 1h3a1.5 1.5 0 0 1 1.415 1H14.5a1.5 1.5 0 0 1 1.493 1.356L16 3.5V4H0V2.5Z"
      />
    </svg>
  );
}
